// import React, { useState, useEffect, useMemo } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import * as actions from "../../Redux/Actions";
// import { Table, OverlayTrigger, Tooltip, Dropdown, Form, Badge } from "react-bootstrap";
// import { formatExperience } from "./utils/formatUtils";
// import { Award } from "./components/Awards/rnr.types";
// import SearchBar from "../../component/SearchBar/SearchBar";
// import FilterValues from "../../component/FieldFilter/FilterValues";
// import AwardEligibilityFilter from "./components/ReportingManagerDetails/AwardEligibilityFilter"; 
// import Button from "../../component/Buttons/Button";
// import { showSuccessToastMessage,showErrorToastMessage } from "../../component/Toasts/Toasts";
// import ReportingManagerDetailsCard from "./components/ReportingManagerDetails/ReportingManagerDetailsCard";
// import NominationModal from "./components/ReportingManagerDetails/NominationModal";
// import TablePagination from "../../component/TablePagination/TablePagination";
// import MainCard from "../../component/MainCard/MainCard";
// import "./RewardsandRecognition.scss";

// interface Employee {
//   _id: string;
//   employeeId: string;
//   candidateName: string;
//   middleName: string;
//   lastname: string;
//   emailId: string;
//   designation: string;
//   location: string;
//   //workLocation: string;
//   organisationExperience: string;
//   clientName: string;
//   projectType: string;
//   projectClassification: string;
//   status: string;
// }

// interface Filters {
//   [key: string]: string[];
// }

// const ReportingManagerTable = () => {
//   const dispatch = useDispatch();
//   const [isLoading, setIsLoading] = useState(true);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedEmployee, setSelectedEmployee] = useState<Employee | null>(null);
//   const [allAwards, setAllAwards] = useState<Award[]>([]);
//   const [ineligibleAwardIds, setIneligibleAwardIds] = useState<string[]>([]);
//   const [unavailableAwardIds, setUnavailableAwardIds] = useState<string[]>([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [employeesPerPage] = useState(5);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filters, setFilters] = useState<Filters>({});
//   const [selectedAwardFilter, setSelectedAwardFilter] = useState<Award | null>(null);

//   const loginUser = localStorage.getItem('login');
//   const managerRef = loginUser ? JSON.parse(loginUser).id : null;

//   const teamData = useSelector((state: any) => state?.employeeReducer?.getEmployeesByManager);
//   const nominationsData = useSelector((state: any) => state?.employeeReducer?.nominationsList);
  
//   const employees = teamData?.data || [];
//   const nominationHistory = nominationsData?.data || []; 

//   useEffect(() => {
//     if (managerRef) {
//       setIsLoading(true);
//       Promise.all([
//         new Promise(resolve => dispatch(actions.getEmployeesByManagerAction(managerRef, resolve))),
//         new Promise(resolve => dispatch(actions.listNominationsAction({ nominatedByRef: managerRef }, resolve))),
//         new Promise(resolve => dispatch(actions.listAwardsAction(resolve))),
//       ]).then(([teamRes, nominationsRes, awardsRes]: any) => {
//         if (!teamRes.success) showErrorToastMessage('Failed to fetch team members.');
//         if (!nominationsRes.success) showErrorToastMessage('Failed to fetch nomination history.');
//         if (awardsRes.success) 
//         { 
//           setAllAwards(awardsRes.data || []);
//         }
//         setIsLoading(false);
//       });
//     } else {
//       setIsLoading(false);
//     }
//   }, [dispatch, managerRef]);

//   const handleOpenNominationModal = (employee: Employee) => {
//     const awardsForThisEmployee = nominationHistory
//       .filter((nom: any) => nom.employeeRef?._id === employee._id)
//       .map((nom: any) => nom.awardRef?._id)
//       .filter(Boolean);

//     const uniqueAwardIds = Array.from(new Set(awardsForThisEmployee.map((id: { toString: () => any; }) => id.toString())));
//     setUnavailableAwardIds(uniqueAwardIds as string[] ?? []);
    
//     const ineligibleIds = allAwards
//       .filter(award => !isEmployeeEligibleForAward(employee, award))
//       .map(award => award._id);
//     setIneligibleAwardIds(ineligibleIds);

//     setSelectedEmployee(employee);
//     setShowModal(true);
//   };

//   const handleCloseNominationModal = () => {
//     setShowModal(false);
//     setSelectedEmployee(null);
//     setUnavailableAwardIds([]);
//   };

//   const convertExperienceToMonths = (expString: string | null | undefined): number => {
//     if (!expString) {
//         return 0;
//     }
//     const parts = String(expString).split('.');
//     const years = parseInt(parts[0], 10) || 0;
//     const months = parts.length > 1 ? (parseInt(parts[1], 10) || 0) : 0;

//     return (years * 12) + months;
//   };

//   const isEmployeeEligibleForAward = (employee: Employee, award: Award): boolean => {
//     const requiredTenure = award.eligibility?.tenure;
//     if (requiredTenure === undefined || requiredTenure === null || requiredTenure === 0) {
//       return true; // No tenure requirement
//     }
//     const employeeMonths = convertExperienceToMonths(employee.organisationExperience);
      
//     return employeeMonths >= requiredTenure;
//   };


//   const filterOptions = useMemo(() => {
//     const options: { [key: string]: string[] } = {
//       designation: [],
//       //workLocation: [],
//       location: [],
//       clientName: [],
//       projectType: [],
//       projectClassification: [],
//     };

//     // const locationSet = new Set<string>();

//     employees.forEach((employee: any) => {
//       // if (employee.location) {
//       //   locationSet.add(employee.location);
//       // }
//       // if (employee.workLocation) {
//       //   locationSet.add(employee.workLocation);
//       // }

//       Object.keys(options).forEach(key => {
//         if (employee[key] && !options[key].includes(employee[key])) {
//           options[key].push(employee[key]);
//         }
//       });
//     });

//     //options.location = Array.from(locationSet).sort();

//     Object.keys(options).forEach(key => options[key].sort());
//     // Object.keys(options).forEach(key => {
//     //   if (key !== 'location') 
//     //   {
//     //     options[key].sort();
//     //   }
//     // });
//     return options;
//   }, [employees]);

//   const processedEmployees = useMemo(() => {
//     let result = employees;

//     if (selectedAwardFilter?.eligibility) {
//       const eligibility = selectedAwardFilter.eligibility;
            
//       result = result.filter((employee: { organisationExperience: string | null | undefined; employmentType: string; }) => {
//         if (eligibility?.tenure) {
//           // const orgExp = parseFloat(employee?.organisationExperience ?? employee?.totalExperience ?? '0');
//           // if (isNaN(orgExp) || orgExp < (eligibility?.tenure / 12)) {
//           //   return false;
//           // }
//           const employeeTotalMonths = convertExperienceToMonths(employee.organisationExperience);
//           if (employeeTotalMonths < eligibility.tenure) {
//             return false; 
//           }
//         }          
//         if (eligibility?.employmentType && eligibility?.employmentType.length > 0) {
//           if (!employee.employmentType || !eligibility.employmentType.includes(employee.employmentType)) {
//             return false; 
//           }
//         }
//         return true;
//       });
//     }

//     // Object.entries(filters).forEach(([field, values]) => {
//     //   if (values.length > 0) {
//     //     result = result.filter((employee: { [x: string]: string; }) => values.includes(employee[field]));
//     //   }
//     // });

//     Object.entries(filters).forEach(([field, values]) => {
//       if (values.length > 0) {
//         if (field === 'location') {
//           result = result.filter((employee: { location: string; workLocation: string; }) => 
//            values.some(value => employee.location === value || employee.workLocation === value)
//           );
//         } else {
//           result = result.filter((employee: { [x: string]: string; }) => values.includes(employee[field]));
//         }
//       }
//     });

//     if (searchQuery) {
//       const lowerCaseQuery = searchQuery.toLowerCase();
//       result = result.filter((employee: any) =>
//         Object.values(employee).some(value => 
//           String(value).toLowerCase().includes(lowerCaseQuery)
//         )
//       );
//     }

//     return result;
//   }, [employees, searchQuery, filters, selectedAwardFilter]);

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [searchQuery, filters, selectedAwardFilter]);

//   const indexOfLastEmployee = currentPage * employeesPerPage;
//   const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;
//   const currentEmployees = processedEmployees.slice(indexOfFirstEmployee, indexOfLastEmployee);
//   const totalPages = Math.ceil(processedEmployees.length / employeesPerPage);

//   const handlePageChange = (pageNumber: React.SetStateAction<number>) => {
//       setCurrentPage(pageNumber);
//   };

//   const handleFilterChange = (field: string, value: string) => {
//     setFilters(prevFilters => {
//       const currentValues = prevFilters[field] || [];
//       const newValues = currentValues.includes(value)
//         ? currentValues.filter(v => v !== value) 
//         : [...currentValues, value]; 
//       if (newValues.length === 0) {
//         const { [field]: _, ...rest } = prevFilters;
//         return rest; 
//       }
      
//       return { ...prevFilters, [field]: newValues };
//     });
//   };

//   const removeFilter = (filterToRemove: { field: string, value: string }) => {
//     handleFilterChange(filterToRemove.field, filterToRemove.value);
//   };
  
//   const activeFiltersForDisplay = Object.entries(filters).flatMap(([field, values]) => 
//     values.map(value => ({ title: `${field}: ${value}`, value: value, field: field }))
//   );

//   useEffect(() => {
//     if (managerRef) {
//       setIsLoading(true);
//       dispatch(
//         actions.getEmployeesByManagerAction(managerRef, (res: any) => {
//           if (!res.success) {
//             console.error("Failed to fetch team:", res.error);
//             showErrorToastMessage(res?.error || "Failed to fetch team");
//           }
//           showSuccessToastMessage(res?.message ?? "Team fetched successfully");
//           setIsLoading(false);
//         })
//       );
//     } 
//     else {
//       setIsLoading(false);
//     }
//   }, [dispatch, managerRef]);

//   // const isEmployeeEligibleForAward = (employee: Employee, award: Award | null): boolean => {
//   //   if (!award) {
//   //     return true; 
//   //   }

//   //   const requiredTenureMonths = award.eligibility?.tenure;
//   //   if (requiredTenureMonths === undefined || requiredTenureMonths === null) {
//   //     return true;
//   //   }
//   //   const orgExp = parseFloat(employee.organisationExperience);
//   //   if (isNaN(orgExp)) {
//   //     return false;
//   //   }
//   //   const employeeTotalMonths = Math.floor(orgExp) * 12 + Math.round((orgExp - Math.floor(orgExp)) * 10);
//   //   return employeeTotalMonths >= requiredTenureMonths;
//   // };

//   return(
//     <div className="d-flex flex-column gap-8">
//       <MainCard>

//        <div className="title-container">
//           <h2>Nominate Employees</h2>
//         </div>

//         {/* Reporting Manager Details - Info Block */}
//         <div className="m-4">
//           <ReportingManagerDetailsCard />
//         </div>
        
//         {/* Search and Filter Bar */}
//         <div className="mt-2">
//           <div className="mt-3 buttonsize filter-wrapper">
//             {/* Search Bar Container */}
//             <div className="emp-searchbar-wrapper">
//               <SearchBar
//                 filter={searchQuery}
//                 setFilter={setSearchQuery}
//                 onSearchClicked={() => {}}
//                 placeholderName="Search by Name, ID, or any field..."
//               />
//             </div>

//             {/* Filter Dropdown Container */}
//             <div className="filters-group">
//               <div className="emp-filter-container emp-filter-container--large">
//                 <div className="filter-dropdown-theme">
//                   <Dropdown autoClose="outside">
//                     <Dropdown.Toggle variant="dark" id="dropdown-filter-by-value" className="w-100">
//                       Filters
//                       {activeFiltersForDisplay.length > 0 && (
//                         <Badge bg="primary" pill className="ms-2">
//                           {activeFiltersForDisplay.length}
//                         </Badge>
//                       )}
//                     </Dropdown.Toggle>
                          
//                     <Dropdown.Menu style={{ height: '300px', maxHeight: '400px', width:'200%', maxWidth:'400px', overflow:'auto' }}>
//                       {activeFiltersForDisplay.length > 0 && (
//                         <>
//                           <Dropdown.Item onClick={() => setFilters({})}>
//                             <span style={{ color: 'red' }}>Clear All Filters</span>
//                             </Dropdown.Item>
//                             <Dropdown.Divider />
//                         </>
//                       )}
                      
//                       {Object.keys(filterOptions).map(field => (
//                         filterOptions[field].length > 0 && (
//                           <React.Fragment key={field}>
//                             <Dropdown.Header>{field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
//                             </Dropdown.Header>
//                             {filterOptions[field].map(option => (
//                               <Dropdown.Item key={option} as="div" className="p-0">
//                                 <Form.Check 
//                                   type="checkbox"
//                                   id={`${field}-${option}`}
//                                   label={option}
//                                   checked={(filters[field] || []).includes(option)}
//                                   onChange={() => handleFilterChange(field, option)}
//                                   className="m-2"
//                                 />
//                               </Dropdown.Item>
//                             ))}
//                           </React.Fragment>
//                         )
//                       ))}
//                     </Dropdown.Menu>
//                   </Dropdown>
//                 </div>
//               </div>

//               {/* Award Eligibility Filter Container */}
//               <div className="emp-filter-container award-filter">
//                 <div className="filter-dropdown-theme">
//                   <AwardEligibilityFilter 
//                     selectedAward={selectedAwardFilter}
//                     onAwardSelect={setSelectedAwardFilter}
//                     awards={allAwards}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Display Active Filters as Tags */}
//             <FilterValues 
//               filterValueArray={activeFiltersForDisplay} 
//               onFilterChange={removeFilter}
//             />
//         </div>

//         {/* Employee Table */}
//         <Table striped bordered hover responsive>
//           <thead>
//             <tr>
//                 <th>Employee ID</th>
//                 <th>Name</th>
//                 <th>Email ID</th>
//                 <th>Status</th>
//                 <th>Designation</th>
//                 <th>Work Location</th>
//                 <th>Employee Tenure</th>
//                 <th>Client Name</th>
//                 <th>Project Type and Classification</th>
//                 <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentEmployees.length > 0 ? (
//                 currentEmployees.map((employee: any) => {
//                   // const isEligibleForSelectedAward = isEmployeeEligibleForAward(employee, selectedAwardFilter);
//                   let isEligibleForSelectedAward = true; 
//                   if (selectedAwardFilter) {
//                     isEligibleForSelectedAward = isEmployeeEligibleForAward(employee, selectedAwardFilter);
//                   }
//                   const isButtonDisabled = !isEligibleForSelectedAward;
//                   const renderTooltip = (props: any) => {
//                       let message = '';
//                       if (!isEligibleForSelectedAward) {
//                           message = `Employee does not meet the minimum tenure of ${selectedAwardFilter?.eligibility?.tenure} months for the selected award.`;
//                       }
//                       return (
//                           <Tooltip id={`tooltip-${employee._id}`} {...props}>
//                               {message}
//                           </Tooltip>
//                       );
//                   };

//                   return (
//                     <tr key={employee._id}>
//                       <td>{employee?.employeeId}</td>
//                       <td>{employee?.candidateName ?? ""} {employee?.middleName ?? ""} {employee?.lastname ?? ""}</td>
//                       <td>{employee?.emailId ?? ""}</td>
//                       <td>
//                         <button
//                           type="button"
//                           className={
//                             `${employee?.status}` === 'Active'
//                                 ? "btn employeedb-status-btn employee-active-btn"
//                                 : `${employee?.status}`  === "Inactive"
//                                 ? "btn employeedb-status-btn employee-inactive-btn"
//                                 : `${employee?.status}`  === "New"
//                                 ? "btn employeedb-status-btn employee-new-btn"
//                                 : "btn employeedb-status-btn employee-draft-btn"
//                           }
//                         >
//                           {`${employee?.status}` || ''} 
//                         </button>
//                       </td>
//                       <td>{employee?.designation ?? ""}</td>
//                       <td>{employee?.location ?? ""}</td>
//                       <td>{formatExperience(employee?.organisationExperience)}</td>
//                       <td>{employee?.clientName ?? ""}</td>
//                       <td>{employee?.projectType ?? ""}, {employee?.projectClassification ?? ""}</td>
//                       <td>
//                         { isButtonDisabled ? (
//                           <OverlayTrigger
//                             placement="top"
//                             delay={{ show: 100, hide: 900 }}
//                             overlay={renderTooltip}
//                           >
//                             <span className="d-inline-block">
//                               <Button
//                                 title="Nominate"
//                                 disabled={true}
//                                 style={{ pointerEvents: 'none' }}
//                                 className="cancel-btn btn"
//                               />
//                             </span>
//                           </OverlayTrigger>
//                         ) : (
//                           <Button
//                             title="Nominate"
//                             disabled={false}
//                             onClick={() => handleOpenNominationModal(employee)}
//                             className="cancel-btn btn"
//                           />
//                         )}
//                       </td>
//                     </tr>
//                   );
//                       })
//                   ) : (
//                     <tr>
//                       <td colSpan={9}>No employees found to be eligible for nomination</td>
//                     </tr>
//                   )}
//           </tbody>
//         </Table>

//         {totalPages > 1 && (
//           <TablePagination
//             totalPages={totalPages}
//             currentPage={currentPage}
//             onClick={handlePageChange}
//           />
//         )}

//         {selectedEmployee && (
//           <NominationModal
//             showModal={showModal}
//             onHide={handleCloseNominationModal}
//             employee={selectedEmployee}
//             unavailableAwardIds={unavailableAwardIds}
//             allAwards={allAwards}
//           />
//         )}
//       </MainCard>
//     </div>
//   )
// }

// export default ReportingManagerTable

import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../Redux/Actions";
import { Table, OverlayTrigger, Tooltip, Dropdown, Form, Badge, Spinner } from "react-bootstrap";
import { formatExperience } from "./utils/formatUtils";
import { Award, Employee } from "./components/Awards/rnr.types";
import SearchBar from "../../component/SearchBar/SearchBar";
import FilterValues from "../../component/FieldFilter/FilterValues";
import AwardEligibilityFilter from "./components/ReportingManagerDetails/AwardEligibilityFilter";
import Button from "../../component/Buttons/Button";
import { showSuccessToastMessage, showErrorToastMessage } from "../../component/Toasts/Toasts";
import ReportingManagerDetailsCard from "./components/ReportingManagerDetails/ReportingManagerDetailsCard";
import NominationModal from "./components/ReportingManagerDetails/NominationModal";
import TablePagination from "../../component/TablePagination/TablePagination";
import MainCard from "../../component/MainCard/MainCard";
import ActionTabs from "../../component/Tabs/Tabs";
import "./RewardsandRecognition.scss";

interface Filters {
  [key: string]: string[];
}

const ReportingManagerTable = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState('myTeam'); // 'myTeam' or 'hrbpTeam' or 'buHeadTeam"
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState<Employee | null>(null);
  const [allAwards, setAllAwards] = useState<Award[]>([]);
  const [unavailableAwardIds, setUnavailableAwardIds] = useState<string[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [employeesPerPage] = useState(5);
  const [searchQuery, setSearchQuery] = useState("");
  const [filters, setFilters] = useState<Filters>({});
  const [selectedAwardFilter, setSelectedAwardFilter] = useState<Award | null>(null);

  const loginUser = localStorage.getItem('login');
  const loggedInUserId = loginUser ? JSON.parse(loginUser).id : null;

  const role = localStorage.getItem("role");
  const isHR = role?.includes("hr") || role?.includes("employee-db-hrmanager") || role?.includes("employee-db-hrbp") || role?.includes("hr-ta");

  // Data from Redux for both tabs
  const managerTeamData = useSelector((state: any) => state?.employeeReducer?.getEmployeesByManager?.data || []);
  const hrbpTeamData = useSelector((state: any) => state?.employeeReducer?.getEmployeesByHRBP?.data || []);
  const buHeadData = useSelector((state: any) => state?.employeeReducer?.getEmployeesByBUHead?.data || []);
  const nominationHistory = useSelector((state: any) => state?.employeeReducer?.nominationsList?.data || []);

  // Fetch all necessary data on component mount
  useEffect(() => {
    if (loggedInUserId) {
      setIsLoading(true);
      Promise.all([
        new Promise(resolve => dispatch(actions.getEmployeesByManagerAction(loggedInUserId, resolve))),
        new Promise(resolve => dispatch(actions.getEmployeesByHrbpAction(loggedInUserId, resolve))), // Fetch HRBP employees
        new Promise(resolve => dispatch(actions.getEmployeesByBUHeadAction(loggedInUserId, resolve))),
        new Promise(resolve => dispatch(actions.listNominationsAction({ nominatedByRef: loggedInUserId }, resolve))),
        new Promise(resolve => dispatch(actions.listAwardsAction(resolve))),
      ]).then(([myTeamRes, myHRBPTeamRes, myBUHeadRes, nominationsRes, awardsRes]: any) => { 
        if(myTeamRes.success) {
          showSuccessToastMessage('My team data fetched successfully.');
        }
        if(myHRBPTeamRes.success && hrbpTeamData.length !== 0) {
          showSuccessToastMessage('My HRBP team data fetched successfully.');
        }
        if(myBUHeadRes.success && buHeadData.length !== 0) {
          showSuccessToastMessage('My BU Head team data fetched successfully.');
        }
        if(nominationsRes.success) {
          showSuccessToastMessage('Nominations data fetched successfully.');
        }
        if (awardsRes.success) {
          setAllAwards(awardsRes.data || []);
        } 
        setIsLoading(false);
      });
    } else {
      setIsLoading(false);
    }
  }, [dispatch, loggedInUserId]);

  // Determine which list of employees to show based on the active tab
  const activeEmployeeList = useMemo(() => {
    switch (activeTab) {
      case 'myTeam':
        return managerTeamData;
      case 'hrbpTeam':
        return hrbpTeamData;
      case 'buHeadTeam':
        return buHeadData;
      default:
        return [];
    }
  }, [activeTab, managerTeamData, hrbpTeamData, buHeadData]);

  const convertExperienceToMonths = (expString: string | null | undefined): number => {
    if (!expString) {
        return 0;
    }
    const parts = String(expString).split('.');
    const years = parseInt(parts[0], 10) || 0;
    const months = parts.length > 1 ? (parseInt(parts[1], 10) || 0) : 0;

    return (years * 12) + months;
  };

  const isEmployeeEligibleForAward = (employee: Employee, award: Award): boolean => {
    const requiredTenure = award.eligibility?.tenure;
    if (requiredTenure === undefined || requiredTenure === null || requiredTenure === 0) {
      return true; // No tenure requirement
    }
    const employeeMonths = convertExperienceToMonths(employee.organisationExperience);
      
    return employeeMonths >= requiredTenure;
  };

  // Shared Modal Logic
  const handleOpenNominationModal = (employee: Employee) => {
    const awardsForThisEmployee = nominationHistory
      .filter((nom: any) => nom.employeeRef?._id === employee._id)
      .map((nom: any) => nom.awardRef?._id)
      .filter(Boolean);

    setUnavailableAwardIds(Array.from(new Set(awardsForThisEmployee)));
    setSelectedEmployee(employee);
    setShowModal(true);
  };

  const handleCloseNominationModal = () => {
    setShowModal(false);
    setSelectedEmployee(null);
    setUnavailableAwardIds([]);
  };

  // Filtering and Searching Logic (now works on the active list)
  const filterOptions = useMemo(() => {
    const options: { [key: string]: string[] } = {
      designation: [], 
      //workLocation: [],
      location: [], 
      clientName: [], 
      projectType: [], 
      projectClassification: [],
    };
    activeEmployeeList.forEach((employee: any) => {
      Object.keys(options).forEach(key => {
        if (employee[key] && !options[key].includes(employee[key])) {
          options[key].push(employee[key]);
        }
      });
    });
    Object.keys(options).forEach(key => options[key].sort());
    return options;
  }, [activeEmployeeList]);

  const processedEmployees = useMemo(() => {
    let result = activeEmployeeList;
    if (selectedAwardFilter) {
      result = result.filter((employee: Employee) => isEmployeeEligibleForAward(employee, selectedAwardFilter));
    }

    Object.entries(filters).forEach(([field, values]) => {
      if (values.length > 0) {
        result = result.filter((employee: any) => values.includes(employee[field]));
      }
    });

    if (searchQuery) {
      const lowerCaseQuery = searchQuery.toLowerCase();
      result = result.filter((employee: any) =>
        Object.values(employee).some(value => String(value).toLowerCase().includes(lowerCaseQuery))
      );
    }
    return result;
  }, [activeEmployeeList, searchQuery, filters, selectedAwardFilter]);

  // Reset pagination when filters or tab change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, filters, selectedAwardFilter, activeTab]);

  // Pagination Logic
  const indexOfLastEmployee = currentPage * employeesPerPage;
  const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;
  const currentEmployees = processedEmployees.slice(indexOfFirstEmployee, indexOfLastEmployee);
  const totalPages = Math.ceil(processedEmployees.length / employeesPerPage);

  const handlePageChange = (pageNumber: number) => setCurrentPage(pageNumber);

  const handleFilterChange = (field: string, value: string) => {
    setFilters(prev => {
      const currentValues = prev[field] || [];
      const newValues = currentValues.includes(value) ? currentValues.filter(v => v !== value) : [...currentValues, value];
      return newValues.length === 0 ? (({ [field]: _, ...rest }) => rest)(prev) : { ...prev, [field]: newValues };
    });
  };

  const activeFiltersForDisplay = Object.entries(filters).flatMap(([field, values]) => 
    values.map(value => ({ title: `${field}: ${value}`, value, field }))
  );

  return (
    <div className="d-flex flex-column gap-8">
      <MainCard>
        <div className="title-container">
          <h2>Nominate Employees</h2>
        </div>

        <div className="m-4">
          <ReportingManagerDetailsCard />
        </div>

        {/* TABS */}
        <div className="profile-tabs-container mb-4">
          <ActionTabs
            title="My Team Nominations"
            onClick={() => setActiveTab('myTeam')}
            active={activeTab === 'myTeam'}
          />
          {hrbpTeamData.length > 0 && (
            <ActionTabs
              title="My HR Scope Nominations"
              onClick={() => setActiveTab('hrbpTeam')}
              active={activeTab === 'hrbpTeam'}
            />
          )}
          {buHeadData.length > 0 && (
            <ActionTabs
              title="My BU Head Scope Nominations"
              onClick={() => setActiveTab('buHeadTeam')}
              active={activeTab === 'buHeadTeam'}
            />
          )}
        </div>

        {/* SHARED SEARCH AND FILTER */}
        <div className="mt-2">
            <div className="mt-3 buttonsize filter-wrapper">
            <div className="emp-searchbar-wrapper">
                <SearchBar 
                  filter={searchQuery} 
                  setFilter={setSearchQuery} 
                  placeholderName="Search employees..."
                  onSearchClicked={() => {}} 
                />
            </div>
            <div className="filters-group">
                <div className="emp-filter-container emp-filter-container--large">
                <div className="filter-dropdown-theme">
                    <Dropdown autoClose="outside">
                    <Dropdown.Toggle variant="dark" id="dropdown-filter-by-value" className="w-100">
                        Filters
                        {activeFiltersForDisplay.length > 0 && <Badge bg="primary" pill className="ms-2">{activeFiltersForDisplay.length}</Badge>}
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ height: '300px', maxHeight: '400px', width:'200%', maxWidth:'400px', overflow:'auto' }}>
                        {activeFiltersForDisplay.length > 0 && (
                        <>
                            <Dropdown.Item onClick={() => setFilters({})}><span style={{ color: 'red' }}>Clear All Filters</span></Dropdown.Item>
                            <Dropdown.Divider />
                        </>
                        )}
                        {Object.keys(filterOptions).map(field => (
                        filterOptions[field].length > 0 && (
                            <React.Fragment key={field}>
                            <Dropdown.Header>{field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}</Dropdown.Header>
                            {filterOptions[field].map(option => (
                                <Dropdown.Item key={option} as="div" className="p-0">
                                <Form.Check type="checkbox" id={`${field}-${option}`} label={option} checked={(filters[field] || []).includes(option)} onChange={() => handleFilterChange(field, option)} className="m-2" />
                                </Dropdown.Item>
                            ))}
                            </React.Fragment>
                        )
                        ))}
                    </Dropdown.Menu>
                    </Dropdown>
                </div>
                </div>
                <div className="emp-filter-container award-filter">
                <div className="filter-dropdown-theme">
                    <AwardEligibilityFilter selectedAward={selectedAwardFilter} onAwardSelect={setSelectedAwardFilter} awards={allAwards}/>
                </div>
                </div>
            </div>
            </div>
            <FilterValues filterValueArray={activeFiltersForDisplay} onFilterChange={(filter: { field: string; value: string; }) => handleFilterChange(filter.field, filter.value)}/>
        </div>

        {/* TABLE & PAGINATION */}
        {isLoading ? (
            <div className="text-center p-5"><Spinner animation="border" /> <p>Loading Employees...</p></div>
        ) : (
          <>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                    <th>Employee ID</th>
                    <th>Name</th>
                    <th>Email ID</th>
                    <th>Status</th>
                    <th>Designation</th>
                    <th>Work Location</th>
                    <th>Employee Tenure</th>
                    <th>Client Name</th>
                    <th>Project</th>
                    <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentEmployees.length > 0 ? (
                  currentEmployees.map((employee: any) => {
                    const isEligible = !selectedAwardFilter || isEmployeeEligibleForAward(employee, selectedAwardFilter);
                    const tooltipMsg = isEligible ? "Employee is eligible for nominations" : `Employee does not meet the tenure requirement for nominations.`;

                    return (
                      <tr key={employee._id}>
                        <td>{employee?.employeeId}</td>
                        <td>{`${employee?.candidateName ?? ""} ${employee?.lastname ?? ""}`}</td>
                        <td>{employee?.emailId ?? ""}</td>
                        <td>
                            <button type="button" className={`${employee?.status}` === 'Active' ? "btn employeedb-status-btn employee-active-btn" : "btn employeedb-status-btn employee-new-btn"}>
                            {`${employee?.status}` || ''} 
                            </button>
                        </td>
                        <td>{employee?.designation ?? ""}</td>
                        <td>{employee?.location ?? ""}</td>
                        <td>{formatExperience(employee?.organisationExperience)}</td>
                        <td>{employee?.clientName ?? ""}</td>
                        <td>{`${employee?.projectType ?? ""}, ${employee?.projectClassification ?? ""}`}</td>
                        <td>
                            <OverlayTrigger placement="top" overlay={<Tooltip>{tooltipMsg}</Tooltip>}>
                                <span className="d-inline-block">
                                <Button
                                    title="Nominate"
                                    disabled={!isEligible}
                                    style={{ pointerEvents: !isEligible ? 'none' : 'auto' }}
                                    onClick={() => handleOpenNominationModal(employee)}
                                    className="cancel-btn btn"
                                />
                                </span>
                            </OverlayTrigger>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={10} className="text-center">No employees found.</td>
                  </tr>
                )}
              </tbody>
            </Table>

            {totalPages > 1 && (
              <TablePagination
                totalPages={totalPages}
                currentPage={currentPage}
                onClick={handlePageChange}
              />
            )}
          </>
        )}

        {selectedEmployee && (
          <NominationModal
            showModal={showModal}
            onHide={handleCloseNominationModal}
            employee={selectedEmployee}
            unavailableAwardIds={unavailableAwardIds}
            allAwards={allAwards}
          />
        )}
      </MainCard>
    </div>
  );
};

export default ReportingManagerTable;